import { Row } from 'react-bootstrap';
import "./campaigndetails.scss";
import AdGroupsList from './AdGroupsList';
const AdGroups = () => {

    return (
        <>
            <div className='table-filtr-wrap mb-3'>
                <Row className=''>
                    <AdGroupsList />
                </Row>
            </div>
        </>
    )
}

export default AdGroups;